import {makeStyles} from "@material-ui/core";
import {green} from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    color: theme.palette.contrastText.main,
  },
  icon: {
    padding: 0,
    marginRight: theme.spacing(2),
    alignSelf: "auto",
  },
  message: {
    padding: 0,
    flexGrow: 1,
  },
  orderLink: {
    wordBreak: "break-all",
  },
  copyLinkButtonText: {
    whiteSpace: "nowrap",
    color: green[500],
  },
  copyLinkButton: {
    flexShrink: 0,
  },
}));
